import { Injectable } from '@angular/core';
import { escapeRegExp, get, isBoolean, isDate } from 'lodash';
import {
    datiqTempateCreateToken,
    DatiqTemplateNonTransformTypes,
    DATIQ_TEMPLATE_TOKEN_REGEX,
    extractPathFromToken,
} from '../models';
import { formatDate } from '@angular/common';

@Injectable({
    providedIn: 'root',
})
export class DatiqTemplateService {
    DATIQ_DATE_FORMAT = 'MM/dd/yyyy';

    constructor() {}

    render(templateString: string, template: unknown): string {
        const paths: string[] = this.getTemplatePaths(templateString);

        return paths.reduce(
            (currentTemplateString: string, path: string): string =>
                this.replaceTokenWithPath(
                    path,
                    currentTemplateString,
                    template,
                ),
            templateString,
        );
    }

    replaceTokenWithPath(
        path: string,
        templateString: string,
        template: unknown,
    ): string {
        const templateValue: any = get(template, path);

        const value: string = this.getTranslatedValue(templateValue) as string;
        const matchingTokens: string[] = String(templateString)?.match(
            escapeRegExp(datiqTempateCreateToken(path)),
        );

        return !!matchingTokens
            ? matchingTokens.reduce(
                  (currentTemplateString: string, matchingToken: string) =>
                      currentTemplateString.replace(
                          datiqTempateCreateToken(path),
                          value,
                      ),
                  templateString,
              )
            : templateString;
    }

    /**
     * Translated a given template value into a valid rendered value
     * ? Should it replace the token if there are no values in the object
     * ? passed or should we actually just keep the token in?
     *
     * @param value : unknown - value from the template
     * @returns a string representing the correct rendered value
     */
    getTranslatedValue(value: unknown): DatiqTemplateNonTransformTypes {
        return isDate(value)
            ? this.getTranslatedValueDate(value)
            : isBoolean(value)
            ? value
            : !!value
            ? (value as DatiqTemplateNonTransformTypes)
            : '';
    }

    private getTranslatedValueDate(value: Date): string {
        return this.getDateString(value);
    }

    getTemplatePaths(templateString: string): string[] {
        const matchingTokens: string[] = String(templateString)?.match(
            DATIQ_TEMPLATE_TOKEN_REGEX,
        );
        return !!matchingTokens
            ? [...matchingTokens].map((matchingToken: string): string =>
                  extractPathFromToken(matchingToken),
              )
            : [];
    }

    getDateString: (date: Date, format?: string) => string = (
        date: Date,
        format: string = this.DATIQ_DATE_FORMAT,
    ): string => formatDate(date, format, 'en-US');
}
